import { Injectable } from '@angular/core';
import { Service } from 'src/app/core/jsonapi/service';
import { VoipScheduleRule } from '../_types/voip-schedule-rule';

@Injectable({
  providedIn: 'root'
})
export class VoipScheduleRulesService extends Service<VoipScheduleRule> {
  public override type = 'voipScheduleRules';
  public override url = 'communications/voipScheduleRules';
}